import React, {useState, useEffect, useRef} from 'react';

import styled from 'styled-components';

const OverlayContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
`;

const SpotlightBox = styled.div<{$x: number; $y: number}>`
  position: absolute;
  left: ${props => props.$x - 40}px;
  top: ${props => props.$y - 20}px;
  width: 80px;
  height: 40px;
  background-color: rgba(255, 0, 0, 0.1);
  border-radius: 4px;
  pointer-events: auto;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
`;

const RulerBand = styled.div<{$y: number}>`
  position: absolute;
  top: ${props => props.$y - 10}px;
  left: 0;
  right: 0;
  height: 32px;
  background-color: rgba(0, 0, 255, 0.1);
  pointer-events: auto;
  cursor: row-resize;
`;

export function PdfOverlays() {
  const [spotlightPos, setSpotlightPos] = useState({x: 100, y: 100});
  const [rulerY, setRulerY] = useState(150);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if (e.altKey && e.shiftKey) {
        if (e.key === 'ArrowUp') {
          setRulerY(y => Math.max(0, y - 20));
          e.preventDefault();
        } else if (e.key === 'ArrowDown') {
          setRulerY(y => y + 20);
          e.preventDefault();
        }
      } else if (e.altKey) {
        if (e.key === 'ArrowUp') {
          setSpotlightPos(p => ({...p, y: Math.max(0, p.y - 20)}));
          e.preventDefault();
        }
        if (e.key === 'ArrowDown') {
          setSpotlightPos(p => ({...p, y: p.y + 20}));
          e.preventDefault();
        }
        if (e.key === 'ArrowLeft') {
          setSpotlightPos(p => ({...p, x: Math.max(0, p.x - 20)}));
          e.preventDefault();
        }
        if (e.key === 'ArrowRight') {
          setSpotlightPos(p => ({...p, x: p.x + 20}));
          e.preventDefault();
        }
      }
    }
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const handleSpotlightDrag = (e: React.MouseEvent) => {
    if (e.buttons !== 1) return;
    const rect = containerRef.current?.getBoundingClientRect();
    if (!rect) return;
    setSpotlightPos({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });
  };

  const handleRulerDrag = (e: React.MouseEvent) => {
    if (e.buttons !== 1) return;
    const rect = containerRef.current?.getBoundingClientRect();
    if (!rect) return;
    setRulerY(e.clientY - rect.top);
  };

  return (
    <OverlayContainer ref={containerRef}>
      <SpotlightBox
        $x={spotlightPos.x}
        $y={spotlightPos.y}
        onMouseMove={handleSpotlightDrag}
        onMouseDown={handleSpotlightDrag}
        title="Alt + Arrow Keys to move"
      />
      <RulerBand
        $y={rulerY}
        onMouseMove={handleRulerDrag}
        onMouseDown={handleRulerDrag}
        title="Alt + Shift + Up/Down to move"
      />
    </OverlayContainer>
  );
}
